<div class="min-h-screen bg-slate-50 font-['DM_Sans',sans-serif]">
  <div class="max-w-8xl mx-auto px-6 py-8">

    <div class="mb-8 animate-fade-in-down">
      <h1 class="text-2xl font-bold text-slate-800 tracking-tight">Settings</h1>
      <p class="text-sm text-slate-500 mt-1">Configure system settings and preferences</p>
    </div>

    <div class="w-fit p-2 bg-white rounded-3xl flex items-center gap-1 mb-6 animate-fade-in" style="animation-delay: 100ms;">
      @for (tab of tabs; track $index) {
        @if (authService.hasAnyRoles(tab.roles)) {
          <button
            (click)="setActiveTab(tab.key)"
            [class]="getTabClass(tab.key)"
            class="flex items-center gap-2 px-4 py-2 rounded-3xl text-sm font-medium transition-all duration-200">
            <svg *ngIf="tab.key === 'workflow'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a2 2 0 012-2h2a2 2 0 012 2m0 0V9a2 2 0 012-2h2a2 2 0 012 2v2m0 0a2 2 0 002 2h2a2 2 0 002-2V9a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
            </svg>
            <svg *ngIf="tab.key === 'users'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <svg *ngIf="tab.key === 'roles'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            <svg *ngIf="tab.key === 'lga'" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.5 12.75H3.75M10.5 12.75C10.5 13.9926 11.5074 15 12.75 15C13.9926 15 15 13.9926 15 12.75C15 11.5074 13.9926 10.5 12.75 10.5C11.5074 10.5 10.5 11.5074 10.5 12.75ZM14.25 5.25H7.5M7.5 5.25C7.5 6.49264 6.49264 7.5 5.25 7.5C4.00736 7.5 3 6.49264 3 5.25C3 4.00736 4.00736 3 5.25 3C6.49264 3 7.5 4.00736 7.5 5.25Z" stroke="#9AA0B3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
    
            {{ tab.label }}
          </button>
        }
      }
    </div>

    <div *ngIf="activeTab === 'workflow'" class="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden animate-fade-in-up">
        <app-workflow-landing></app-workflow-landing>
    </div>

    <div *ngIf="activeTab === 'users'"
      class="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden animate-fade-in-up">
      <app-user-landing></app-user-landing>
    </div>

    <div *ngIf="activeTab === 'roles'"
      class="bg-white rounded-2xl shadow-sm border border-slate-100 text-center animate-fade-in-up">
      <app-role-landing></app-role-landing>
    </div>

    <div *ngIf="activeTab === 'mda'"
      class="bg-white rounded-2xl shadow-sm border border-slate-100 text-center animate-fade-in-up">
        <app-lga-settings-landing></app-lga-settings-landing>
    </div>
  </div>
</div>
<!-- Click-outside overlay to close menu -->
<div *ngIf="openMenuIndex !== null"
  class="fixed inset-0 z-10"
  (click)="openMenuIndex = null">
</div>
